import EncylopeiaManagementUnitRevert from 'components/AfterCopyright/EncylopediaManagementUnit/EncylopeiaManagementUnitRevert';
import { useParams } from 'react-router-dom';

import AfterCopyrightDecisionForm from './AfterCopyrightDecisionForm';

function RevertDecision() {
  const { offerID, committee, status, step } = useParams();
  return (
    <AfterCopyrightDecisionForm
      offerID={offerID}
      committee={committee}
      status={status}
    >
      <EncylopeiaManagementUnitRevert
        isEncyclopediaUnitControl={committee === 'eu_control'}
        hideDescription
        step={step}
        status={status}
        committee={committee}
      />
    </AfterCopyrightDecisionForm>
  );
}
export default RevertDecision;
